import React, { FC, PropsWithChildren } from "react";
import styled from "@emotion/styled";
import { ScreenSize } from "@constants/screen-size";
import { useMediaQuery } from "react-responsive";
import { useTranslation } from "react-i18next";

const SignInContainer = styled.div`
  display: flex;
  height: 100%;
  width: 100%;
`;

const LeftSide = styled.div`
  width: 100%;
  overflow: auto;
  display: flex;
  align-items: center;
  justify-content: center;

  @media (min-width: ${ScreenSize.lg}px) {
    width: 50%;
  }

  @media (min-width: ${ScreenSize.xl}px) {
    width: 50%;
  }
`;

const RightSide = styled.div`
  flex: 1;
  position: relative;
`;

const MainImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

const Text = styled.div`
  text-align: center;
  position: absolute;
  top: 15%;
  left: 50%;
  color: white;
  transform: translate(-50%, -50%);
`;

const SideImageLayout: FC<PropsWithChildren> = ({ children }) => {
  const { t } = useTranslation();
  const isBigScreen = useMediaQuery({
    query: `(min-width: ${ScreenSize.lg}px)`,
  });
  return (
    <SignInContainer>
      <LeftSide>{children}</LeftSide>
      {isBigScreen && (
        <RightSide>
          <MainImage
            src={`${process.env.PUBLIC_URL}/images/signin-art.jpg`}
            alt="Main image"
          />

          <Text>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: "15px",
              }}
            >
              <img
                src={`${process.env.PUBLIC_URL}/images/logo.png`}
                height="60px"
                alt="Logo"
              ></img>
              <span style={{ fontSize: "40px" }}>
                {process.env.REACT_APP_APP_NAME}
              </span>
            </div>
            <div style={{ fontSize: "22px", marginTop: "20px" }}>
              {t("sideImagePanel.title")}
            </div>
          </Text>
        </RightSide>
      )}
    </SignInContainer>
  );
};

export default SideImageLayout;
